import type { StorefrontNetworkAndPvRecCategory } from '@api/storefrontsNetworkPvRec';
import { useAppSelector } from '@redux/hooks';
import { useAtomValue } from 'jotai';
import type { Raw } from 'types/vendor';
import { storefrontsNetworkDataAtom } from '../../../../../jotai/storefront/storefronts-network-pvrec';

/** @internal */
export function extractVendorsFromNetwork(
	network: StorefrontNetworkAndPvRecCategory[],
	maxVendors: number,
): Raw[] {
	const vendors: Raw[] = [];

	for (const category of network) {
		const networkVendors = category.storefrontNetwork.map(
			(item) => item.profile,
		);
		vendors.push(...networkVendors);

		if (vendors.length >= maxVendors) break;
	}

	return vendors.slice(0, maxVendors);
}

export function usePrepareVendorsForGrid(maxGridSize = 5): Raw[] {
	const vendor = useAppSelector((state) => state.vendor.vendorRaw);
	const { network } = useAtomValue(storefrontsNetworkDataAtom);
	const networkVendors = extractVendorsFromNetwork(network, maxGridSize - 1);
	return vendor ? [vendor, ...networkVendors] : [];
}

export const getVendorImage = (vendor: Raw): string | null => {
	return (
		vendor.mediaSummary?.media?.[0]?.url || vendor.storefrontCard?.url || null
	);
};
